import { create } from 'zustand';

import type { MenuItem } from '../types/types';
import { CANVAS_CONTEXT_MENU_FIXED_POSITION } from '../config/constants';

export interface ContextMenuState {
  contextMenuPos: { x: number; y: number } | null;
  menuItems: MenuItem[];
  setContextMenuPos: (pos: { x: number; y: number } | null) => void;
  setMenuItems: (items: MenuItem[]) => void;
  resetMenu: () => void;
}

export const useContextMenuStore = create<ContextMenuState>((set) => ({
  contextMenuPos: CANVAS_CONTEXT_MENU_FIXED_POSITION,
  menuItems: [],

  setContextMenuPos: (pos) => {
    set({ contextMenuPos: pos });
  },

  setMenuItems: (items) => {
    set({ menuItems: items });
  },

  // contextMenuPos: null (comment this because menuItems fixed pos and visible always)
  resetMenu: () => {
    set({ menuItems: [] });
  },
}));
